import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../stores/slices/user/userSlice';

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // useUserAuth();
  useEffect(() => {
    dispatch(logout());
    navigate('/', { replace: true });
    // eslint-disable-next-line
  }, []);
};

export default Logout;
